import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';
import { AuthGuard } from '../_guards/auth.guard';
import { OnboardingComponent } from './pages/onboarding/onboarding.component'
import { LandingEmpresaComponent } from './pages/landing-empresa/landing-empresa.component';
import { LandingGeneralComponent } from './pages/landing-general/landing-general.component';
import { LibroCompraVentaComponent } from './pages/libro-compra-venta/main/libro-compra-venta.component';
import { ActualizarCredencialesComponent } from './pages/actualizar-credenciales/actualizar-credenciales.component'


// rutas
const routes: Routes = [
  { path: '', component: LandingComponent, 
  // canActivate: [AuthGuard], 
  data: {title: 'gtp-principal'},
  children: [
    {
      path: '',
      component: LandingGeneralComponent
    },
    {
      path: 'onboarding',
      component: OnboardingComponent
    },
    {
      path: 'landing-empresa',
      component: LandingEmpresaComponent
    },
    {
      path: 'libro-compra-venta',
      loadChildren: () =>
        import('./pages/libro-compra-venta/libro-compra-venta.module').then(
          (module) => module.LibroCompraVentaModule
        ),
    },
    {
      path: 'actualizar-credenciales',
      component: ActualizarCredencialesComponent
    },
    {
      path: 'payment',
      loadChildren: () =>
        import('./pages/payment/payment.module').then(
          (module) => module.PaymentModule
        ),
    },
    // PARA CUANDO SE SUBA OFERTAS FINANCIERAS
    {
      path: 'ofertas',
      loadChildren: () =>
        import('./pages/ofertas-financieras/ofertas-financieras.module').then(
          (module) => module.OfertasFinancierasModule
        ),
    },
    // PARA CUANDO SE SUBA COBRANZA ONLINE
    {
      path: 'cobranza-online',
      loadChildren: () =>
        import('./pages/cobranza-online/cobranza-online.module').then(
          (module) => module.CobranzaOnlineModule
        ),
    },
  ]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyPageRoutingModule { }
